import {getContext, hasContext, setContext} from 'svelte';
import type {Readable} from 'svelte/store';
import type { Table } from '@tanstack/svelte-table';
import type {GridCommand, GridSettings} from 'shared/ui-widgets/grid/types';
import {GridStateManager} from './state/state-management';
import {Subject} from 'rxjs';

const GRID_CONTEXT_KEY = 'grid-context-key';

export interface GridContext<ROW> {
    table$: Readable<Table<ROW>>;
    settings: GridSettings<ROW>;
    stateManager: GridStateManager;
    command$: Subject<GridCommand>;
}

export function setGridContext<ROW>(table$: Readable<Table<ROW>>, settings: GridSettings<ROW>) {
    const command$ = new Subject<GridCommand>();
    const ctx: GridContext<ROW> = {
        settings,
        table$,
        stateManager: new GridStateManager(settings, command$),
        command$
    };
    setContext(GRID_CONTEXT_KEY, ctx);
}

export function getGridContext<ROW>() {
    if (!hasContext(GRID_CONTEXT_KEY)) {
        throw new Error('Grid context is required!');
    }

    return getContext<GridContext<ROW>>(GRID_CONTEXT_KEY);
}